/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Sso_X15_FailedInputs */



/**
* | output |
* | --- |
* | "Your company's sign-in service did not answer as expected. Try again in a moment." |
*
* @param {Signin_Sso_X15_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const signin_sso_x15_failed = /** @type {((inputs?: Signin_Sso_X15_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Sso_X15_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Your company's sign-in service did not answer as expected. Try again in a moment.")
});